import React,{useEffect, useState} from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';
import { DeleteClientService, FilterClientService } from '../../services/ClientService';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { Modal } from 'antd';
import toast from 'react-hot-toast';
import { DatePicker } from 'antd';
import OpinionMenu from './OpinionMenu';
import { DeleteOpinionFileService, GetOpinionFileService } from '../../services/OpinionFileService';
import { RiBillLine } from 'react-icons/ri';
import { useSelector } from 'react-redux';

function OpinionList() {

  const roles = useSelector(state=>state.Auth.roles)

  const [page,setpage] = useState(1)
  const [modal,setmodal] = useState(false)
  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
  const [data,setdata] = useState({})  
  const [selecteddata,setselecteddata] = useState({})  

  const {pathname} = useLocation()
  const path = pathname?.split('/')[pathname?.split('/')?.length - 1]
  const [step,setstep] = useState(1)
  
  const steps = [
    'Pending',
    'In Progress',
    'Completed',
    'Hold',
  ]

  useEffect(()=>{
    getData()
  },[page,path,step])

  async function getData(){
    const response = await GetOpinionFileService(page,search?.text,search?.from_date1,search?.to_date1,path,step)
    setdata(response?.data)
  }

  const navigate = useNavigate() 

  async function applyfilter(){
    const response = await GetOpinionFileService(1,search?.text,search?.from_date1,search?.to_date1,path,step)
    setdata(response?.data)
  }

  async function resetfunc(){
    setpage(1)
    setsearch({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
    const response = await GetOpinionFileService(1,'','','',path,step)
    setdata(response?.data)
  }  

  async function deleteData(){
    const response = await DeleteOpinionFileService(selecteddata?._id)
    if(response?.status === 200){
      getData()
      setmodal(false)
      toast.success("Deleted Successfully!")
    }
  }

  // console.log("search",search)

  return (
    <div className='md:flex pt-5 md:pt-0 '>
        <Modal className='absolute top-0  left-[40%]' width={300} footer={false} closable={false} open={modal}>
          <div>
            <h6 className='text-[13px] font-[700]'>Delete Data</h6>
            <h6 className='text-[12px] bg-slate-100 p-[4px]'>Are you sure want to delete the selected Data</h6>
             
            <div className='my-1'>
               <h6 className='text-[11px]'>Name : <span className='font-[700]'>{selecteddata?.name}</span></h6>
               <h6 className='text-[11px]'>Mobile : <span className='font-[700]'>{selecteddata?.mobile}</span></h6>
            </div> 

            <div className='flex items-center mt-2 border-t pt-2'>
               <ButtonOutlinedAutoWidth onClick={()=>setmodal(false)} btnName="Cancel" />
               <h6 className='w-[10px]'></h6>
               <ButtonFilledAutoWidth btnName="Save" onClick={deleteData} />
            </div>
          </div>

        </Modal>
        <OpinionMenu />
        <div className='md:w-[85%] px-4 pt-2 md:pt-2'>
        <div className='flex flex-col md:flex-row border-b pb-2 border-slate-200 w-[100%] md:items-center justify-between'>
          {/* <h6 className='font-[600] text-[14px] '>{'Total Opinion List'} ({data?.pagination?.total})</h6> */}

          <div className='flex items-center justify-between'>
          <h6 className='font-[600] text-[14px] '>{`Total Opinion List`} ({data?.pagination?.total})</h6>

          <div className='flex md:hidden items-center'>
            <div className='flex md:hidden items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>
        </div>    
        </div>

          <div className='flex flex-col md:flex-row md:items-center mt-2'>
            <div className='hidden md:flex items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>

            <div className='flex'>
              <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.from_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,from_date:v,from_date1:v1})}} /> 

              <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.to_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,to_date:v,to_date1:v1})}} /> 

              
              <input id="search_text" placeholder='Search ...' type='text' value={search?.text}  onChange={(e)=>setsearch({...search,text:e.target.value})} className='border text-sm py-[4px] focus:ring-0  focus:outline-0 text-[13px]  w-28 px-1 rounded-md border-slate-300' />
            </div>

            <div className="mt-2 md:mt-0 md:ml-2 flex">
              <ButtonOutlinedAutoWidth onClick={()=>{setpage(1);applyfilter()}}  btnName="Add Filter" />

              <div className="ml-2">
              <ButtonFilledAutoWidth btnName="Add New" onClick={()=>navigate('create')}   />
              </div> 
            </div> 
          </div>
       </div>
       <div className='border-b flex items-center'>
       {steps?.map((s,i)=>(
        <h6 onClick={()=>{setstep(i+1);setpage(1)}} className={` ${step === i+1 ? 'bg-[#1b3f69] text-white' : ''} cursor-pointer px-2 p-1.5 text-[10px] font-[600]`}>{s}</h6>
       ))}
       </div>
       
       
        {data?.datas?.length === 0 &&
            <div className='grid place-items-center mt-20  items-center justify-center'>
            <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
            <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
            <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
          </div>
          }

          {data?.datas?.length > 0 &&
          <div className='max-h-[82vh] mt-4 border-t   border-l border-r overflow-y-scroll'>
            <div className='sticky top-0 z-50 flex w-max md:w-[100%] bg-white py-[-5px] border-b border-slate-200 relative'>
                <h6  className='top-0 bg-white z-50 text-[12px] w-[60px] min-w-[60px] md:w-[5%]  px-2 py-1 font-[600] text-slate-600 border-r flex items-center justify-center'>Sl No</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[150px] min-w-[150px] md:w-[12%]  px-2 py-1 font-[600] text-slate-600 border-r'>Client Name</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[140px] min-w-[140px] md:w-[12%]  px-2 py-1 font-[600] text-slate-600 border-r'>Office File No</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[150px] min-w-[150px] md:w-[15%] px-2 py-1 font-[600] text-slate-600 border-r'>Property Details</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[180px] min-w-[180px] md:w-[16%] px-2 py-1 font-[600] text-slate-600 border-r'>Work Details</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[160px] min-w-[160px] md:w-[15%] px-2 py-1 font-[600] text-slate-600 border-r'>Allocation Of Work</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[160px] min-w-[160px] md:w-[15%] px-2 py-1 font-[600] text-slate-600 border-r'>Summary</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[60px] min-w-[60px] md:w-[10%]   px-2 py-1 font-[600] text-slate-600'>Actions</h6>
            </div>
            {data?.datas?.map((d,i)=>(
            <div className='flex w-max md:w-[100%] bg-white py-[-5px] border-b border-slate-200 relative'>
                <h6  className='bg-white truncate z-50 text-[12px] w-[60px] min-w-[60px] md:w-[5%]  px-2 py-1 text-black border-r flex items-center justify-center'>{page == 1 ? i+1 : (data?.pagination?.limit * (page - 1)) + (i+1)}</h6>
                <h6 className='text-[12px] truncate md:w-[12%] w-[150px] min-w-[150px] px-2 py-1 opacity-70  text-black border-r'>{d?.client?.name} / {d?.client?.mobile}</h6>
                <h6 className='text-[12px] truncate md:w-[12%] w-[140px] min-w-[140px] px-2 py-1  opacity-70 text-black border-r'>{d?.office_file_no}</h6>
                <h6 className='text-[12px] truncate md:w-[15%] w-[150px] min-w-[150px] px-2 py-1 opacity-70  text-black border-r'>{d?.property_details}</h6>
                <h6 className='text-[12px] truncate md:w-[16%] w-[180px] min-w-[180px] px-2 py-1  opacity-70 text-black border-r'>{d?.work_details} </h6>
                <h6 className='text-[12px] truncate md:w-[15%] w-[160px] min-w-[160px] px-2 py-1  opacity-70 text-black border-r'>{d?.allocation_of_work?.name}</h6>
                <h6 className='text-[12px] truncate md:w-[15%] w-[160px] min-w-[160px] capitalize  px-2 py-1  opacity-70 text-black border-r'>{d?.comments}</h6>
                <h6 className='text-[12px] flex truncate w-[60px] min-w-[60px] md:w-[10%]  px-2 py-1  opacity-70 text-black '>
                  <RiBillLine className='mr-2' onClick={()=>{navigate('detail',{state:d})}} />
                  <AiOutlineEdit className='mr-2' onClick={()=>{navigate('edit',{state:d})}} />
                  {['admin','Admin']?.filter((f)=>roles?.includes(f))?.length > 0 &&
                  <AiOutlineDelete onClick={()=>{setselecteddata(d);setmodal(true)}} />}
                </h6>
            </div>))}
          </div>}
       </div>
       
    </div>
  )
}

export default OpinionList